import { FC } from 'react';
import { ForgotPinModalProps } from './forgot.type';
import Close from '../../assets/close.png';
import './forgot.css';
import { Trans } from 'react-i18next';

const ForgotPinModal: FC<ForgotPinModalProps> = (props) => {
  if (!props.isOpen) return null;

  return (
    <div
      className="forgot-pin-main-modal-container"
      data-testid="forgot-pin-modal"
    >
      <div className="forgot-modal-container">
        <button
          onClick={props.onClose}
          className="close-button"
          data-testid="forgot-pin-modal-close-button"
        >
          <img src={Close} alt="Show Password" className="w-4 h-4" />
        </button>

        <h2 className="forgot-text">
          {' '}
          <Trans i18nKey="login.forgotPin" />
        </h2>

        <p className="forgot-desc" data-testid="forgot-pin-desc">
          <Trans i18nKey="login.forgotMemberDesc1" />
          <br />
          <Trans i18nKey="login.forgotMemberDesc12" />
        </p>
      </div>
    </div>
  );
};

export default ForgotPinModal;
